export interface CreativeImageDimensions {
  width: number;
  height: number;
}

export const DEFAULT_CREATIVE_IMAGE_DIMENSIONS: CreativeImageDimensions = {
  width: 1280,
  height: 720,
};

export const SWITCH_IN_LEFT_CREATIVE_DIMENSIONS: CreativeImageDimensions = {
  width: 284,
  height: 720,
};

export const SWITCH_IN_BOTTOM_CREATIVE_DIMENSIONS: CreativeImageDimensions = {
  width: 996,
  height: 160,
};

export interface ExtendedFile extends File {
  objectURL: string;
}

export async function areCreativeDimensionsValid(
  file: ExtendedFile[],
  dimensions: CreativeImageDimensions = DEFAULT_CREATIVE_IMAGE_DIMENSIONS,
): Promise<boolean> {
  if (file.length === 0) {
    return false;
  }

  return new Promise((resolve) => {
    const image = new Image();
    image.src = file[0].objectURL;

    image.onload = () => {
      const { width, height } = image;
      const isValid = width === dimensions.width && height === dimensions.height;
      resolve(isValid);
    };

    image.onerror = () => {
      resolve(false);
    };
  });
}
